// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1CF0Y","name":"Header_name__wm_HF","birthday":"Header_birthday__1Xj8O","skeleton":"Header_skeleton__1EmQG"};